import styled from 'styled-components';

import { Button, Text12SB } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ButtonStyled = styled(Button)`
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
`;

export const Title = styled(Text12SB)`
  letter-spacing: 0.5px;
`;
